import { render } from "./IconElipsis.vue?vue&type=template&id=5100f6b0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconElipsis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5100f6b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5100f6b0', __exports__)) {
    api.reload('5100f6b0', __exports__)
  }
  
  module.hot.accept("./IconElipsis.vue?vue&type=template&id=5100f6b0", () => {
    api.rerender('5100f6b0', render)
  })

}


export default __exports__